// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__32LP0","title":"Images45_title__apgWv","images":"Images45_images__2gRC7"};